module.exports = __webpack_public_path__ + "img/homebanner.557afe00.png";